export default function OffreSpeciale() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-blue-600 via-teal-600 to-blue-700 relative overflow-hidden">
      {/* Éléments décoratifs de fond */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-10 left-10 w-72 h-72 bg-white rounded-full blur-3xl"></div>
        <div className="absolute bottom-10 right-10 w-96 h-96 bg-white rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-12">
          {/* Badge Offre Spéciale */}
          <div className="inline-flex items-center px-6 py-3 bg-white/20 backdrop-blur-sm border-2 border-white/40 text-white rounded-full text-sm font-bold mb-6 animate-pulse">
            <i className="ri-flashlight-fill mr-2 text-yellow-300"></i>
            OFFRE EXCEPTIONNELLE
            <i className="ri-flashlight-fill ml-2 text-yellow-300"></i>
          </div>

          <h2 className="text-5xl md:text-6xl font-black text-white mb-6 leading-tight">
            Demandes Qualifiées à Prix Unique
          </h2>
          <p className="text-2xl text-white/90 max-w-3xl mx-auto mb-8">
            Accédez aux coordonnées complètes de clients prêts à acheter pour seulement
          </p>

          {/* Prix en évidence */}
          <div className="bg-white rounded-3xl p-12 max-w-4xl mx-auto shadow-2xl mb-8 transform hover:scale-105 transition-transform duration-300">
            <div className="flex items-center justify-center gap-8 mb-6">
              <div className="text-left">
                <div className="text-gray-400 line-through text-3xl font-bold mb-2">75€</div>
                <div className="text-sm text-red-600 font-bold">Prix habituel</div>
              </div>
              <div className="w-1 h-20 bg-gray-200"></div>
              <div className="text-center">
                <div className="flex items-start justify-center">
                  <span className="text-7xl md:text-8xl font-black text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-teal-600">
                    35
                  </span>
                  <span className="text-4xl font-black text-gray-900 ml-2 mt-4">€</span>
                </div>
                <div className="text-xl font-bold text-gray-600 mt-2">Par Lead Qualifié</div>
              </div>
              <div className="w-1 h-20 bg-gray-200"></div>
              <div className="text-right">
                <div className="text-3xl font-black text-green-600 mb-2">-53%</div>
                <div className="text-sm text-green-600 font-bold">Économie</div>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
              <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl p-4 border-2 border-blue-200">
                <i className="ri-user-star-line text-3xl text-blue-600 mb-2"></i>
                <div className="font-bold text-gray-900 text-lg">Client Qualifié</div>
                <div className="text-sm text-gray-600">Demande vérifiée</div>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl p-4 border-2 border-teal-200">
                <i className="ri-phone-line text-3xl text-teal-600 mb-2"></i>
                <div className="font-bold text-gray-900 text-lg">Coordonnées Complètes</div>
                <div className="text-sm text-gray-600">Nom, téléphone, email</div>
              </div>
              <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-xl p-4 border-2 border-blue-200">
                <i className="ri-time-line text-3xl text-blue-600 mb-2"></i>
                <div className="font-bold text-gray-900 text-lg">Accès Immédiat</div>
                <div className="text-sm text-gray-600">Après paiement</div>
              </div>
            </div>

            <button 
              onClick={() => scrollToSection('demandes')}
              className="w-full bg-gradient-to-r from-blue-600 to-teal-600 text-white px-8 py-5 rounded-xl text-xl font-black hover:from-blue-700 hover:to-teal-700 transition-all transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <i className="ri-shopping-cart-line mr-3 text-2xl"></i>
              Voir les Leads Disponibles
              <i className="ri-arrow-right-line ml-3 text-2xl"></i>
            </button>
          </div>

          {/* Avantages CLÉS - Mise en avant des points demandés */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 max-w-6xl mx-auto mb-8">
            <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/30 transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-yellow-400 to-yellow-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-vip-crown-line text-3xl text-white"></i>
              </div>
              <div className="font-black text-white text-2xl mb-3">Lead Exclusif</div>
              <div className="text-white/90 text-base font-medium leading-relaxed">
                Jamais revendu à d'autres professionnels. Le lead est 100% à vous !
              </div>
            </div>

            <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/30 transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-green-400 to-green-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <div className="font-black text-white text-2xl mb-3">Pas d'Engagement</div>
              <div className="text-white/90 text-base font-medium leading-relaxed">
                Aucun contrat, aucun abonnement. Vous ne payez que ce que vous recevez.
              </div>
            </div>

            <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/30 transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-teal-400 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-hand-heart-line text-3xl text-white"></i>
              </div>
              <div className="font-black text-white text-2xl mb-3">Liberté Totale</div>
              <div className="text-white/90 text-base font-medium leading-relaxed">
                Arrêtez ou reprenez quand vous voulez. Vous êtes 100% libre de vos choix.
              </div>
            </div>

            <div className="bg-white/15 backdrop-blur-sm rounded-2xl p-8 border-2 border-white/30 transform hover:scale-105 transition-all">
              <div className="w-16 h-16 bg-gradient-to-br from-blue-400 to-blue-500 rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg">
                <i className="ri-whatsapp-line text-3xl text-white"></i>
              </div>
              <div className="font-black text-white text-2xl mb-3">Envoi Direct</div>
              <div className="text-white/90 text-base font-medium leading-relaxed">
                Lead envoyé instantanément sur WhatsApp. Contactez le client en 2 minutes !
              </div>
            </div>
          </div>

          {/* Bloc de réassurance supplémentaire */}
          <div className="bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-2xl p-8 max-w-4xl mx-auto mb-8">
            <div className="flex items-center justify-center gap-4 mb-6">
              <i className="ri-checkbox-circle-fill text-4xl text-green-300"></i>
              <h3 className="text-3xl font-black text-white">Pourquoi Nous Choisir ?</h3>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
              <div className="flex items-start gap-3">
                <i className="ri-close-circle-line text-2xl text-red-300 mt-1"></i>
                <div>
                  <div className="font-bold text-white text-lg mb-1">Pas d'Abonnement Mensuel</div>
                  <div className="text-white/80 text-sm">Fini les frais fixes qui plombent votre trésorerie</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-close-circle-line text-2xl text-red-300 mt-1"></i>
                <div>
                  <div className="font-bold text-white text-lg mb-1">Pas de Minimum d'Achat</div>
                  <div className="text-white/80 text-sm">Achetez 1 lead ou 100, c'est vous qui décidez</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-green-300 mt-1"></i>
                <div>
                  <div className="font-bold text-white text-lg mb-1">Payez Uniquement les Leads Reçus</div>
                  <div className="text-white/80 text-sm">Transparence totale, aucun frais caché</div>
                </div>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-green-300 mt-1"></i>
                <div>
                  <div className="font-bold text-white text-lg mb-1">Pause et Reprise à Volonté</div>
                  <div className="text-white/80 text-sm">Adaptez votre activité selon vos besoins</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Compteur d'urgence */}
        <div className="bg-white/10 backdrop-blur-sm border-2 border-white/30 rounded-2xl p-6 max-w-2xl mx-auto text-center">
          <div className="flex items-center justify-center gap-3 mb-3">
            <i className="ri-fire-line text-3xl text-yellow-300 animate-pulse"></i>
            <span className="text-white font-bold text-xl">Offre Limitée</span>
            <i className="ri-fire-line text-3xl text-yellow-300 animate-pulse"></i>
          </div>
          <p className="text-white/90 text-lg">
            <strong className="text-yellow-300">47 professionnels</strong> ont déjà profité de cette offre aujourd'hui
          </p>
        </div>
      </div>
    </section>
  );
}